import React from 'react';
import ReactDOM from 'react-dom';

import './index.scss';
import { AppContainer } from './containers';

ReactDOM.render(<AppContainer />, document.getElementById('react-mount-point'));
